// extracted by mini-css-extract-plugin
export default {"item":"Item_item__qYihr","anchor":"Item_anchor__a++RK","title":"Item_title__TsleX"};